import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import * as myGlobals from '../globals';
import { LanguageService } from '../language.service';
import { Configuration } from '../app.configuration';
import { ConfigService } from '../config.service';

import { FacebookLoginProvider, GoogleLoginProvider, AuthService } from 'angularx-social-login';
import { TranslateService } from '@ngx-translate/core';


declare var jQuery: any;
declare var $: any;
declare var Fingerprint: any;
declare const swal: any;
declare const moment: any;
declare var toastr: any;

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  date: any = moment().format('YYYY-MM-DD HH:mm:ss');
  time: any = moment().format('YYYY-MM-DD HH:mm:ss');
  errMsg: any;
  errLogin: any;
  errSignup: any;
  errCheckMail: any;
  errCheckPhone: any;
  errForgotPass: any;
  errCheckPromo: any;
  emailAddress: any;
  phoneNumber: any;
  languageLogin: any;
  languageCreateAccount: any;
  languageForgotPassword: any;
  check;
  sub;
  signup_mail: any;
  signup_number: any;
  singup_pass: any;
  signup_name: any;
  signup_lname: any;
  signup_otpcode: any;
  email_response: any;
  phone_response: any;
  current_lat: any;
  current_lng: any;
  socialMedia_id: any;
  signin_name: any;
  signin_img: any;
  mail_bool = false;
  num_bool = false;
  timer_i = 60;
  counter_bool = false;
  signup_reff = '';
  password_mail = '';
  forgot_mobile: any;
  verify_otp_type: any;
  forget_pass: any;
  forget_c_pass: any;
  termsand_cond = false;
  file: any;
  photo: any;
  privacy_policy: any;
  terms_conditions: any;
  window: any = window;
  login_button_disabled: false;
  userId: any;
  version: any;
  password_mail1: any;
  password_phone: any;
  ent_password: any;
  ent_email: any;
  ent_longitude = 13.0287;
  ent_latitude = 77.5896;
  fingerprint = new Fingerprint().get();
  sid: any;
  isCustomerLogin = true;
  allLanguages = [];
  defaultLanguage = 'en';

  constructor(
    private _conf: Configuration,
    private _loginService: LoginService,
    private _router: Router,
    public authService: AuthService,
    private languageService: LanguageService,
    private _cookie: ConfigService,
    private translate: TranslateService
  ) { }

  // Sign in facebook
  signIn() {
    // console.log('facebook');
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then(res => {
      // console.log(res);
      const logintype = '2';
      this.ent_email = res.email;
      this.ent_password = res.id;
      this.signin_name = res.name;
      this.signin_img = res.photoUrl;
      this.socialMedia_id = res.id;
      this.emmualLogin(logintype, this.socialMedia_id);
    }).catch(err => {
      console.log(err);
    });
  }

  // Sign in Google
  signIngoogle() {
    // console.log('google');
    this.authService
      .signIn(GoogleLoginProvider.PROVIDER_ID)
      .then(res => {
        //  console.log(res);
        const logintype = '3';
        this.ent_email = res.email;
        this.ent_password = res.id;
        this.signin_name = res.name;
        this.signin_img = res.photoUrl;
        this.socialMedia_id = res.id;
        this.emmualLogin(logintype, this.socialMedia_id);
      })
      .catch(err => {
        console.log(err);
      });
  }

  // OTP Timer
  onTimer() {
    const mycounter_fun = setInterval(() => {
      this.timer_i--;
      if (this.timer_i < 0) {
        $('#mycounter').text('');
        this.counter_bool = true;
        clearInterval(mycounter_fun);
      } else {
        $('#mycounter').text('Resend after ' + this.timer_i + ' secs');
      }
    }, 1000);
  }

  // OTP Resend
  otpresend() {
    $('#loader').show();
    this._loginService
      .signupotpresend({
        userId: this.userId
      })
      .subscribe(
        () => {
          $('.form').animate({ left: '-645px', opacity: 0 }, 400);
          setTimeout(function () {
            $('.form').hide();
            $('.wrap').show();
            $('#1').focus();
          }, 405);
          this.timer_i = 60;
          this.counter_bool = false;
          this.onTimer();
          this.verify_otp_type = 2;
          $('#loader').hide();
        },
        err => {
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              $('#loader').hide();
              toastr['error']('Bad Gateway!');
              break;
            case 520:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              // this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 400:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 420:
              this.errSignup = err.error;
              this.errSignup = this.errSignup.message;
              $('#loader').hide();
              break;
          }
        }
      );
  }

  // OTP Send
  otpsend() {
    $('.terms_error').remove();
    if (this.termsand_cond == false) {
      $('.switch_div').append(
        '<span class="terms_error" style="color:red">Please accept the terms and conditions</span>'
      );
    } else {
      this.signup_otpcode =
        $('#1').val() + $('#2').val() + $('#3').val() + $('#4').val();
      $('#loader').show();
      this._loginService
        .signupotp({
          code: this.signup_otpcode,
          userId: this.userId
        })
        .subscribe(
          () => {
            $('.form').animate({ left: '-645px', opacity: 0 }, 400);
            setTimeout(function () {
              $('.form').hide();
              $('.wrap').show();
              $('#1').focus();
            }, 405);
            this.timer_i = 60;
            this.counter_bool = false;
            this.onTimer();
            this.verify_otp_type = 2;
            $('#loader').hide();
          },
          err => {
            if (err.status > 401 && err.status < 500) {
              err.status = 420; // merging all the status codes to one status code 420
            }
            if (err.status > 499) {
              err.status = 520; // merging all the status codes to one status code 420
            }
            switch (err.status) {
              case 0:
                $('#loader').hide();
                toastr['error']('Bad Gateway!');
                break;
              case 520:
                $('#loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 401:
                // this._cookie.removeItem();
                this._router.navigate(['login']);
                break;
              case 400:
                $('#loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 420:
                this.errSignup = err.error;
                this.errSignup = this.errSignup.message;
                $('#loader').hide();
                break;
            }
          }
        );
    }
  }
  otpSubmitActive;
  // Change otp submit button color change
  onOtpFilled() {
    // commented as the verificaation code is hardcoded -Vivek
    // const arr = otp.split('');
    // if (arr.length == 4) {
    //   this.otpSubmitActive = true;
    // } else {
    //   this.otpSubmitActive = false;
    // }
    // console.log(arr);
  }
  // OTP Verify
  verify_otp() {
    $('#loader').show();
    this.signup_otpcode =
      $('#1').val() + $('#2').val() + $('#3').val() + $('#4').val();
    console.log(this.signup_otpcode);
    this._loginService
      .verifyotp({
        code: this.signup_otpcode,
        userId: this.userId
      })
      .subscribe(
        (res: any) => {
          if (this.signup_mail != '' && this.signup_mail != undefined) {
            // this._cookie.setItem(res.data);
            this._conf.setItem(res, 'token', res.data.token);
            localStorage.setItem('dev', this.fingerprint);
            sessionStorage.setItem('authtoken', res.data.token);
            sessionStorage.setItem('mqtt', res.data.mqttTopic);
            sessionStorage.setItem('sid', res.data.sid);
            this._router.navigate(['dispatcher']);
          } else {
            $('#otp_error').text(res.errMsg);
            $('#loader').hide();
            $('#sendForgotPass').hide();
            $('#register-form').hide();
            $('#login-form').hide();
            $('#forgot-password').hide();
            $('#confirm-password').show();
            $('.form').show();
          }
        },
        err => {
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              $('#loader').hide();
              toastr['error']('Bad Gateway!');
              break;
            case 520:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              // this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 400:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 420:
              this.errSignup = err.error;
              this.errSignup = this.errSignup.message;
              $('#loader').hide();
              break;
          }
        }
      );
  }

  // Signup call
  signup_call() {
    $('#loader').show();
    this.signup_api();
    // if (this.file != undefined) {
    //   this.addphoto();
    // }
    // else {
    //   this.signup_api();
    // }
  }

  // Forgot Password
  forgotPassType(value) {
    if (value == 2) {
      this.forgot_mobile = 2;
      $('#pass_mail').show();
      $('#pass_phone').hide();
      this.change_bools(0);
      $('#pass_mail').removeClass('has-error');
    } else {
      this.forgot_mobile = 1;
      $('#pass_mail').hide();
      $('#pass_phone').show();
      this.change_bools(1);
      $('#pass_phone').removeClass('has-error');
    }
  }

  // Change screen to OTP screen
  changeOtpScreen() {
    $('.form').animate({ left: '-645px', opacity: 0 }, 400);
    setTimeout(function () {
      $('.form').hide();
      $('.wrap').show();
      $('#1').focus();
    }, 405);
    this.timer_i = 60;
    this.counter_bool = false;
    this.onTimer();
    this.verify_otp_type = 2;
    $('#loader').hide();
  }

  // Signup API call
  signup_api() {
    $('.terms_error').remove();
    if (this.termsand_cond == false) {
      $('#loader').hide();
      $('.switch_div').append(
        '<span class="terms_error" style="color:red">Please accept the terms and conditions</span>'
      );
    } else {
      const countryData = $('#phone').intlTelInput('getSelectedCountryData')
        .dialCode;
      this._loginService
        .signupcall({
          firstName: this.signup_name,
          lastName: this.signup_lname,
          email: this.signup_mail,
          deviceId: this.fingerprint.toString(),
          password: this.singup_pass,
          countryCode: '+' + countryData,
          phone: this.signup_number,
          devType: '3',
          deviceOsVersion: 'web',
          deviceTime: this.time,
          appVersion: myGlobals.version,
          devMake: 'web',
          devModel: 'web',
          referralCode: this.signup_reff,
          profilePic: this.photo,
          loginType: '1',
          facebookId: this.socialMedia_id,
          googleId: this.socialMedia_id,
          latitude: this.current_lat,
          longitude: this.current_lng,
          billingAddress2: 'default',
          ipAddress: ''
        })
        .subscribe(
          (res: any) => {
            $('#signup_mail').trigger('click');
            $('.register-form #err').hide();
            this.userId = res.data.sid;
            this.changeOtpScreen();
          },
          err => {
            if (err.status > 401 && err.status < 500) {
              err.status = 420; // merging all the status codes to one status code 420
            }
            if (err.status > 499) {
              err.status = 520; // merging all the status codes to one status code 420
            }
            switch (err.status) {
              case 0:
                $('.loader').hide();
                toastr['error']('Bad Gateway!');
                break;
              case 520:
                $('.loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 401:
                // this._cookie.removeItem();
                this._router.navigate(['login']);
                break;
              case 400:
                $('.loader').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 420:
                setTimeout(() => {
                  this.errSignup = '';
                }, 5000);
                this.errSignup = err.error;
                this.errSignup = this.errSignup.message;
                $('.loader').hide();
                $('.register-form #err').show();
                break;
            }
          }
        );
    }
  }

  // Referral Code Verification
  passPromocode(e) {
    if ($('#promo').val().length > 3) {
      $('.loader_promo').hide();
      $('.promo_error').remove();
      this._loginService
        .promocode({
          referralCode: e
        })
        .subscribe(
          (res: any) => {
            $('.promo_error').remove();
            console.log('response', res);
            $('.loader_promo').hide();
            $('.promo_validation #err').hide();
            $('.promo_validation').addClass('has-success');
            $('.promo_validation').removeClass('has-error');
          },
          err => {
            if (err.status > 401 && err.status < 500) {
              err.status = 420; // merging all the status codes to one status code 420
            }
            if (err.status > 499) {
              err.status = 520; // merging all the status codes to one status code 420
            }
            switch (err.status) {
              case 0:
                $('.loader_promo').hide();
                toastr['error']('Bad Gateway!');
                break;
              case 520:
                $('.loader_promo').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 401:
                // this._cookie.removeItem();
                this._router.navigate(['login']);
                break;
              case 400:
                $('.loader_promo').hide();
                this.errMsg = err.error;
                toastr['error'](this.errMsg.message);
                break;
              case 420:
                this.errCheckPromo = err.error;
                this.errCheckPromo = this.errCheckPromo.message;
                $('.loader_promo').hide();
                $('.promo_validation #err').show();
                $('.promo_validation').removeClass('has-success');
                $('.promo_validation').addClass('has-error');
                break;
            }
          }
        );
    }
  }

  ngOnInit() {
    this.getLanguages();
    $('.modal-backdrop').hide();
    this.version = myGlobals.version;
    $('.email_validation #signup_mail').keyup(function () {
      $('.email_validation #err').hide();
    });

    $('.phone_validation #phone').keyup(function () {
      $('.phone_validation #err').hide();
    });

    $('#pass_mail').hide();
    this.forgot_mobile = 1;

    // Toaseter
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '3000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };

    this.languageLogin = this.languageService.login;
    this.languageCreateAccount = this.languageService.create_account;
    this.languageForgotPassword = this.languageService.Forgot_Password;

    // Loader
    jQuery('#loader').show();
    this.privacy_policy = myGlobals.privacy_policy;
    this.terms_conditions = myGlobals.terms_conditin;
    // var autocomplete;
    // autocomplete = new google.maps.places.Autocomplete(
    //         /** @type {!HTMLInputElement} */(document.getElementById('autocomplete1')));

    // Routing based on Token
    // if (this._cookie.getItem('token')) {
    //   this._router.navigate(['dispatcher']);
    // }
    // else {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(e => {
        this.current_lat = e.coords.latitude;
        this.current_lng = e.coords.longitude;
      });
    } else {
      jQuery.get(
        'https://ipinfo.io',
        response => {
          this.current_lat = response.loc.split(',')[0];
          this.current_lng = response.loc.split(',')[1];
        },
        'jsonp'
      );
    }

    $.fn.focusNextInputField = function () {
      return this.each(function () {
        const fields = $(this)
          .parents('form:eq(0),body')
          .find('button,input,textarea,select');
        const index = fields.index(this);
        if (index > -1 && index + 1 < fields.length) {
          fields.eq(index + 1).focus();
        }
        return false;
      });
    };

    $.fn.focusPrevInputField = function () {
      return this.each(function () {
        const fields = $(this)
          .parents('form:eq(0),body')
          .find('button,input,textarea,select');
        const index = fields.index(this);
        if (index > -1 && index - 1 < fields.length) {
          fields.eq(index - 1).focus();
        }
        return false;
      });
    };

    $('.module input').keyup(function (e) {
      const code = e.keyCode || e.which;
      if ($(this).val().length > 0) {
        if ($(this).attr('id') === '4') {
          $('.one').css({ 'box-shadow': '0 0 10px #1EB2F7' });
          $('.one').css({ 'box-shadow': 'none' });
          $(this).blur();
          $('.send').removeClass('send_animate');
          $('.send').addClass('signup_inst');
        }
        if (code !== 4) {
          $(this).focusNextInputField();
        }
      } else {
        $('.send').addClass('send_animate');
        $('.send').removeClass('signup_inst');
        if ($(this).attr('id') !== '1') {
          $(this).focusPrevInputField();
        }
      }
    });

    $('.send_animate').click(function () {
      $('.send_animate')
        .animate({ left: '-15px' }, 100)
        .animate({ left: '15px' }, 100)
        .animate({ left: '0px' }, 100);
    });

    $('#signup_inst').click(() => {
      this.verify_otp();
      // if (!$("#signup_inst").hasClass('send_animate')) {
      //   this.verify_otp();
      // }
    });
    jQuery('#loader').hide();

    $('.message a').click(function () {
      $('form').animate({ height: 'toggle', opacity: 'toggle' }, 'slow');
      $('#forgot-password').hide();
      $('#confirm-password').hide();
    });
    $('.message1 a').click(function () {
      $('form').hide();
      $('#confirm-password').hide();
      $('#forgot-password').show();
    });
    $('.toggle').on('click', function () {
      $('.container')
        .stop()
        .addClass('active');
    });

    $('.close').on('click', function () {
      $('.container')
        .stop()
        .removeClass('active');
    });
    const telInput = $('#phone'),
      errorMsg = $('#error-msg'),
      validMsg = $('#valid-msg');
    const reset = function () {
      telInput.removeClass('error');
      errorMsg.addClass('hide');
      validMsg.addClass('hide');
    };

    telInput.blur(function () {
      reset();
      if ($.trim(telInput.val())) {
        if (telInput.intlTelInput('isValidNumber')) {
          validMsg.removeClass('hide');
        } else {
          telInput.addClass('error');
          errorMsg.removeClass('hide');
        }
      }
    });

    // on keyup reset
    telInput.on('keyup change', reset);
    $('#phone').intlTelInput({
      autoHideDialCode: true,
      geoIpLookup: function (callback) {
        $.get('https://ipapi.co/json/').always(function (res) {
          if (res.status >= 400 || res.error) {
            $.get('https://ipinfo.io', function () { }, 'jsonp').always(function (
              resp
            ) {
              console.log(resp);
              const countryCode = resp && resp.country ? resp.country : '';
              callback(countryCode);
            });
          } else {
            const countryCode = res && res.country ? res.country : '';
            callback(countryCode);
          }
        });
      },
      initialCountry: 'auto',
      nationalMode: true,
      separateDialCode: true,
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js'
    });
    $('#passwordPhone').intlTelInput({
      autoHideDialCode: true,
      geoIpLookup: function (callback) {
        $.get('https://ipapi.co/json/').always(function (res) {
          if (res.status >= 400 || res.error) {
            $.get('https://ipinfo.io', function () { }, 'jsonp').always(function (
              resp
            ) {
              console.log(resp);
              const countryCode = resp && resp.country ? resp.country : '';
              callback(countryCode);
            });
          } else {
            const countryCode = res && res.country ? res.country : '';
            callback(countryCode);
          }
        });
      },
      initialCountry: 'auto',
      nationalMode: true,
      separateDialCode: true,
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js'
    });
    // Forgot Password
    $('#forgot-password').validate({
      rules: {
        email_phone: {
          eitherEmailPhone: true,
          required: true
        }
      },
      highlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
      },
      unhighlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-error')
          .addClass('has-success');
      },
      submitHandler: () => {
        this.forgot_pass();
      }
    });

    // Confirm Password
    $('#confirm-password').validate({
      rules: {
        forgot_password: {
          minlength: 3
        },
        conf_password: {
          minlength: 3,
          equalTo: '#for_Password'
        }
      },
      highlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
      },
      unhighlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-error')
          .addClass('has-success');
      },
      submitHandler: () => {
        this.update_pass();
      }
    });

    // Login Form Validation
    $('.login-form').validate({
      rules: {
        ent_email: {
          eitherEmailPhone: true,
          required: true
        },
        ent_password: {
          minlength: 3,
          required: true
        }
      },
      highlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
      },
      unhighlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-error')
          .addClass('has-success');
      },
      submitHandler: () => {
        setTimeout(() => {
          this.emmualLogin(1, 0);
        }, 500);
      }
    });

    // Phone Validation
    $('#phone').keypress(function (event) {
      const $this = $(this);
      if (
        (event.which != 46 || $this.val().indexOf('.') != -1) &&
        (event.which < 48 || event.which > 57) &&
        event.which != 0 &&
        event.which != 8
      ) {
        event.preventDefault();
      }

      const text = $(this).val();
      if (event.which == 46 && text.indexOf('.') == -1) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if (
        text.indexOf('.') != -1 &&
        text.substring(text.indexOf('.')).length > 2 &&
        event.which != 0 &&
        event.which != 8 &&
        $(this)[0].selectionStart >= text.length - 2
      ) {
        event.preventDefault();
      }
    });

    // Email Validation
    $.validator.addMethod(
      'eitherEmailPhone',
      function (value, element) {
        const isPhone =
          (this.optional(element) || /^\d+$/.test(value)) &&
          this.getLength($.trim(value), element) == 10 &&
          this.getLength($.trim(value), element) == 10;
        const isEmail =
          this.optional(element) ||
          /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
            value
          );
        return isPhone || isEmail;
      },
      this.languageCreateAccount.emailValid
    );

    $('.register-form').validate({
      rules: {
        username: {
          minlength: 3,
          required: true
        },
        phone: {
          uniqueUserName: true,
          required: true
        },
        email: {
          email: true,
          required: true
        },
        password: {
          minlength: 3,
          required: true
        }
      },
      success: element => {
        if (
          $(element)
            .closest('.form-group')
            .hasClass('email_validation') &&
          this.mail_bool == false
        ) {
          $('.loader_email').show();
          this.check_mail();
        }
        if (
          $(element)
            .closest('.form-group')
            .hasClass('phone_validation') &&
          this.num_bool == false
        ) {
          $('.loader_phone').show();
          this.check_phone();
        }
      },
      highlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
        $(element)
          .closest('.form-group')
          .removeClass('has-success')
          .addClass('has-error');
      },
      unhighlight: function (element) {
        $(element)
          .closest('.form-group')
          .removeClass('has-error')
          .addClass('has-success');
      },
      submitHandler: () => {
        if (this.mail_bool && this.num_bool) {
          this.signup_call();
        }
      }
    });

    $.validator.addMethod(
      'uniqueUserName',
      function () {
        if (telInput.intlTelInput('isValidNumber')) {
          return true;
        } else {
          return false;
        }
      },
      this.languageCreateAccount.numberValid
    );

    $.validator.addMethod('checkmail', () => {
      this.check_mail();
    });
  }
  change_bools(field_id) {
    if (field_id == 0) {
      this.mail_bool = false;
    } else {
      console.log('signup_number', this.signup_number)
      this.num_bool = false;
    }
  }

  // Update Forgot Password
  update_pass() {
    this._loginService
      .updatePass({
        password: this.forget_c_pass,
        userId: this.sid
      })
      .subscribe(() => {
        swal('Password Changed!', 'Please login in to continue !', 'success');
        $('form').hide();
        $('.login-form').show();
        $('#for_Password').val('');
      });
  }

  // Terms & Condition
  termsandcond() {
    if (this.termsand_cond) {
      this.termsand_cond = false;
    } else {
      this.termsand_cond = true;
    }
    $('.terms_error').remove();
  }

  // Email Verification
  check_mail() {
    this._loginService
      .verifymail({
        email: this.signup_mail
      })
      .subscribe(
        () => {
          $('.email_validation #err').hide();
          $('.email_validation').addClass('has-success');
          $('.email_validation').removeClass('has-error');
          $('.loader_email').hide();
          this.mail_bool = true;
          this.email_response = true;
        },
        err => {
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              $('.loader_email').hide();
              toastr['error']('Bad Gateway!');
              break;
            case 520:
              $('.loader_email').hide();
              this.mail_bool = false;
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              // this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 400:
              $('.loader_email').hide();
              this.mail_bool = false;
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 420:
              $('.loader_email').hide();
              $('.email_validation #err').show();
              this.mail_bool = false;
              this.errCheckMail = err.error;
              this.errCheckMail = this.errCheckMail.message;
              $('.email_validation').addClass('has-error');
              $('.email_validation').removeClass('has-success');
              $('.email_validation #err').trigger('click');
              break;
          }
        }
      );
  }

  onUploadFinished(e) {
    const response = JSON.parse(e.serverResponse._body);
    $('#imagePreview').css('background-image', 'url(' + e.target.result + ')');
    $('#imagePreview').hide();
    $('#imagePreview').fadeIn(650);
    this.file.push(response.data.url);
  }
  // File Reader
  imgsrc(fileInput: any) {
    this.photo = '';
    const that = this;
    const input = fileInput.srcElement;
    if (input.files && input.files[0]) {
      that._loginService.uploadImages(fileInput.target.files[0]).subscribe(
        (data: any) => {
          this.photo = data.data.url;
        },
        error => {
          console.log(error);
        }
      );
      const reader = new FileReader();
      reader.onload = function (e: any) {
        console.log(e.target.result);
        $('#imagePreview').css(
          'background-image',
          'url(' + e.target.result + ')'
        );
        $('#imagePreview').hide();
        $('#imagePreview').fadeIn(650);
      };
      reader.readAsDataURL(input.files[0]);
    }
    this.file = fileInput.target.files[0];
    console.log(fileInput);
    console.log(this.file);
  }

  clear_error() {
    $('.forgeterror').remove();
    $('.forget_validation').removeClass('has-success');
    $('.forget_validation').removeClass('has-error');
  }

  // Forgot Password
  forgot_pass() {
    const countryData = $('#passwordPhone').intlTelInput(
      'getSelectedCountryData'
    ).dialCode;
    $('#loader').show();
    $('.forgeterror').remove();
    if (this.forgot_mobile == 1) {
      this.password_mail = this.password_phone;
    } else {
      this.password_mail = this.password_mail1;
    }
    this._loginService
      .forgotPass({
        emailOrPhone: this.password_mail,
        countryCode: '+' + countryData,
        type: this.forgot_mobile
      })
      .subscribe(
        (res: any) => {
          this.sid = res.data.sid;
          // this._cookie.setForgotPass(res.data);
          $('#forget_pass').addClass('');
          $('#forgot-password #err').hide();
          this.clear_error();
          this.userId = res.data.sid;
          if (this.forgot_mobile == 2) {
            $('#success_mail').modal('show');
            $('form').hide();
            $('.login-form').show();
            $('#forgot-password').hide();
          } else {
            $('#back_send').show();
            setTimeout(function () {
              $('.form').hide();
              $('.wrap').show();
              $('#1').focus();
            }, 405);
            this.timer_i = 60;
            this.counter_bool = false;
            this.onTimer();
            this.signup_number = this.password_mail;
            this.verify_otp_type = 1;
            $('#loader').hide();
          }
        },
        err => {
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              $('#loader').hide();
              toastr['error']('Bad Gateway!');
              break;
            case 520:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              // this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 400:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 420:
              $('#loader').hide();
              setTimeout(() => {
                this.errForgotPass = '';
              }, 5000);
              this.errForgotPass = err.error;
              this.errForgotPass = this.errForgotPass.message;
              $('#pass_phone').removeClass('has-success');
              $('#pass_phone').addClass('has-error');
              $('#pass_mail').removeClass('has-success');
              $('#pass_mail').addClass('has-error');
              break;
          }
        }
      );
  }

  // Back Button For Forgot Password
  forgotBack() {
    $('#pass_mail').hide();
    $('#pass_phone').show();
    $('#loader').hide();
    $('form').hide();
    $('.login-form').show();
    $('#forgot-password').hide();
    $('#forgot-password').trigger('reset');
    $('#pass_mail, #pass_phone').removeClass('has-error');
    $('#pass_mail, #pass_phone').removeClass('has-success');
  }

  confirmBack() {
    $('#loader').hide();
    $('form').hide();
    $('.login-form').hide();
    $('#forgot-password').show();
    $('#confirm-password').hide();
    $('#confirm-password').trigger('reset');
    $('#for_Password, #con_Password').removeClass('has-error');
    $('#for_Password, #con_Password').removeClass('has-success');
  }

  handleError(text) {
    $('.phone_validation').addClass('has-success');
    $('.phone_validation').removeClass('has-error');
    $("label[for='signup_number']").text(text);
    $('.loader_phone').hide();
    this.num_bool = false;
  }

  // Phone Number Varification
  check_phone() {
    const countryData = $('#phone').intlTelInput('getSelectedCountryData')
      .dialCode;
    this._loginService
      .verifyphone({
        countryCode: '+' + countryData,
        phone: this.signup_number
      })
      .subscribe(
        () => {
          $('.phone_validation #err').hide();
          $('.phone_validation').addClass('has-success');
          $('.phone_validation').removeClass('has-error');
          $('.loader_phone').hide();
          this.num_bool = true;
          this.phone_response = true;
        },
        err => {
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          this.num_bool = false;
          switch (err.status) {
            case 0:
              $('#loader').hide();
              toastr['error']('Bad Gateway!');
              break;
            case 520:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              // this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 400:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 420:
              this.errCheckPhone = err.error;
              this.errCheckPhone = this.errCheckPhone.message;
              $('.loader_phone').hide();
              $('.phone_validation #err').show();
              $('.phone_validation').removeClass('has-success');
              $('.phone_validation').addClass('has-error');
              $('.phone_validation #err').trigger('click');
              break;
          }
        }
      );
  }

  backsend() {
    $('.module.inp.test input').val('');
    $('.wrap').animate({ left: '-625px', opacity: 0 }, 400);
    $('.form').animate({ left: '0px', opacity: 1 }, 400);
    setTimeout(function () {
      $('.form').show();
      $('.wrap').hide();
      $('.wrap').animate({ left: '0px', opacity: 1 });
    }, 405);
  }

  // LOGIN SERVICE GOES HERE!!!
  emmualLogin(logintype, socialMedia_id) {
    const time_stamp = moment().unix();
    this.fingerprint = this.fingerprint + time_stamp;
    if (logintype == 1) {
    }
    if (socialMedia_id == 0) {
      socialMedia_id = '';
    }
    jQuery('#loader').show();
    this._loginService
      .login({
        emailOrPhone: this.ent_email.toLowerCase(),
        password: this.ent_password,
        deviceId: this.fingerprint.toString(),
        appVersion: myGlobals.version,
        devMake: 'web',
        devModel: 'web',
        devType: '3',
        deviceTime: this.time,
        loginType: logintype,
        deviceOsVersion: 'web',
        facebookId: socialMedia_id,
        googleId: socialMedia_id,
        latitude: this.current_lat,
        longitude: this.current_lng,
        ipAddress: '',
        type: this.isCustomerLogin
      })
      .subscribe(
        (res: any) => {
          $('.login-form #err').hide();
          console.log(res);
          this._cookie.setSetting(res.data);
          this._conf.setItem(res, 'token', res.data.token);
          // this._conf.setItem(res, "googleMapApiKeyTopic", res.data.googleMapApiKeyTopic);
          sessionStorage.setItem(
            'googleMapApiKeyTopic',
            res.data.googleMapApiKeyTopic
          );
          localStorage.setItem('dev', this.fingerprint);
          sessionStorage.setItem('authtoken', res.data.token);
          sessionStorage.setItem('mqtt', res.data.mqttTopic);
          sessionStorage.setItem('sid', res.data.sid);
          setTimeout(() => {
            this._router.navigate(['dispatcher']);
          }, 1000);
          // this._cookie.setItem(res.data);
          // this._router.navigate(['dispatcher']);
        },
        err => {
          console.log('errMsg', err.status);
          if (err.status > 404 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              $('#loader').hide();
              toastr['error']('Bad Gateway!');
              break;
            case 520:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 401:
              // this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 400:
              $('#loader').hide();
              this.errMsg = err.error;
              toastr['error'](this.errMsg.message);
              break;
            case 404:
              if (socialMedia_id) {
                $('form').animate(
                  { height: 'toggle', opacity: 'toggle' },
                  'slow'
                );
                $('#forgot-password').hide();
                $('#confirm-password').hide();
                $('#loader').hide();
                this.signup_mail = this.ent_email;
                this.photo = this.signin_img;
                $('#imagePreview').css(
                  'background-image',
                  'url(' + this.signin_img + ')'
                );
                this.signup_name = this.signin_name;
                setTimeout(() => {
                  $('#signup_name').focus();
                  $('#signup_name').blur();
                  $('#signup_mail').focus();
                  $('#signup_mail').blur();
                }, 500);
              } else {
                setTimeout(() => {
                  this.errLogin = '';
                }, 5000);
                this.errLogin = err.error;
                this.errLogin = this.errLogin.message;
                $('#loader').hide();
                $('.login-form #err').show();
              }
              break;
            case 402:
            case 403:
            case 420:
              setTimeout(() => {
                this.errLogin = '';
              }, 5000);
              this.errLogin = err.error;
              this.errLogin = this.errLogin.message;
              $('#loader').hide();
              $('.login-form #err').show();
              break;
          }
        }
      );
  }

  toggleLoginType() {
    this.isCustomerLogin = !this.isCustomerLogin;
    // console.log('this.isCustomerLogin', this.isCustomerLogin);
  }

  getLanguages() {
    this._loginService.getLanguages().subscribe(
      (res: any) => {
        console.log(res);
        this.allLanguages = res.data;
        this.translate.setDefaultLang('en');
        this._cookie.setItems('lang', 'en');
        if (this._cookie.getItem('lang')) {
          this.defaultLanguage = this._cookie.getItem('lang');
          const index = this.allLanguages.find(
            language => language.code === this.defaultLanguage
          );
          if (index) {
            this.translate.use(this.defaultLanguage);
          } else {
            this.translate.use('en');
          }
        } else {
          this.translate.use('en');
        }

        console.log(this.defaultLanguage, this._cookie.getItem('lang'));
      },
      err => {
        console.log(err);
      }
    );
  }

  /**
  *
  *
  * @param string lang
  * @memberof DispatcherComponent
  * @description switch language
  */
  changeLanguage(lang) {
    this.translate.use(lang);
    this._cookie.setNewCookie('lang', lang, 10);
  }
}
